import L from "leaflet";
import { Marker } from "react-leaflet";
import { Tunnel } from "../../../services/RuteplanAPI";
import tunnelIconResource from "../../../assets/tunnel.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const tunnelIcon = L.icon({
    iconUrl: tunnelIconResource,
    iconRetinaUrl: tunnelIconResource,
    iconAnchor: [14,28],
    iconSize: [28, 28]
});

export interface ITunnelMarkersProps {
    tunneler: Array<Tunnel>;
}

export default function TunnelMarkers(props: ITunnelMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const {tunneler} = props;

    return (
        <>
        {tunneler && tunneler.map((tunnel: Tunnel, index: number) => {
            return (
                <Marker key={tunnel.nvdbId + index}
                position={[tunnel.location!.y, tunnel.location!.x]}
                icon={tunnelIcon}
                eventHandlers={{
                    click: () => {
                        setClickedRoadFeature(tunnel);
                        setRoadFeatureDialogIsOpen(true);
                    }
                }} 
                />
            )
        })}
        </>
    )
}